export default "__VITE_ASSET__6ad978c5__"